import { createContext, useContext } from 'react';
import { User } from 'modules/graphql';

export type UsersQueryContextType = {
  getUserById: (id: string) => User | undefined;
  isLoadingUsers: boolean;
  refetchUsers: () => void;
  users: User[];
};

const defaultState = {
  getUserById: () => undefined,
  isLoadingUsers: false,
  refetchUsers: () => undefined,
  users: [],
};

export const UsersQueryContext = createContext<UsersQueryContextType>(defaultState);

export const useUsersQueryContext = () => useContext<UsersQueryContextType>(UsersQueryContext);
